import React from 'react';
import * as S from './style';

import { Label, Btn } from 'components';
import * as PAGE_URL from 'router/PageUrl';
import {
  PAGE_MAIN_TITLE_1,
  PAGE_MAIN_TITLE_2,
  PAGE_MAIN_CAPTION_1,
  PAGE_MAIN_CAPTION_2,
  BUTTON_SIGNUP_1,
  BUTTON_LOGIN_2,
} from 'commons/ZimssaString';

function Intro(): React.ReactElement {
  return (
    <S.ContentsWrapper>
      <S.TitleContainer>
        <S.TitleWrapper>
          <Label
            contents={PAGE_MAIN_TITLE_1}
            fontStyle={'h3_bold'}
            color={'gray_opacity_50'}
            wordBreak={true}
          />
        </S.TitleWrapper>
        <S.TitleWrapper>
          <Label
            contents={PAGE_MAIN_TITLE_2}
            fontStyle={'h3_bold'}
            color={'gray_opacity_50'}
            wordBreak={true}
          />
        </S.TitleWrapper>
      </S.TitleContainer>
      <S.CaptionContainer>
        <S.CaptionWrapper>
          <Label
            contents={PAGE_MAIN_CAPTION_1}
            fontStyle={'body2'}
            color={'gray_neautral_300'}
            wordBreak={true}
          />
        </S.CaptionWrapper>
        <S.CaptionWrapper>
          <Label
            contents={PAGE_MAIN_CAPTION_2}
            fontStyle={'body2'}
            color={'gray_neautral_300'}
            wordBreak={true}
          />
        </S.CaptionWrapper>
      </S.CaptionContainer>
      <S.BtnContainer>
        <S.BtnWrapper>
          <Btn
            fontStyle={'body2_bold'}
            color={'gray_opacity_50'}
            backGroundColor={'blue_900'}
            height={52}
            href={PAGE_URL.SIGNUP.url}
          >
            {BUTTON_SIGNUP_1}
          </Btn>
        </S.BtnWrapper>
        <S.BtnWrapper>
          <S.BtnSignInStyled
            fontStyle={'body2'}
            color={'gray_opacity_50'}
            backGroundColor={'transparent'}
            href={PAGE_URL.LOGIN.url}
          >
            {BUTTON_LOGIN_2}
          </S.BtnSignInStyled>
        </S.BtnWrapper>
      </S.BtnContainer>
    </S.ContentsWrapper>
  );
}

export default Intro;
